module.exports = __webpack_public_path__ + "img/black-back-button.9a89d779.svg";